var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M9 11.5V13h4a3 3 0 0 0 0-6H9v4.5zM9 14v5.5a.5.5 0 1 1-1 0V6h5a4 4 0 1 1 0 8H9zM5 3v18.5a.5.5 0 1 1-1 0V3H2.5a.5.5 0 0 1 0-1h18a.5.5 0 0 1 .5.5v19a.5.5 0 1 1-1 0V3H5z" })
  );
});